import React, { useState, useEffect } from "react";
import firebase from "./firebase";
// import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Login from "./userAuth/login";
import Home from "./userAuth/home";

function App() {
  const [User, setUser] = useState();

  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      setUser(user);
      // console.log(user);
    });
  }, []);

  return (
    <div className="App">{!User ? <Login /> : <Home user={User.email} />}</div>
  );
}

export default App;
